var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewPayment = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "background",
    width: 32,
    height: 32,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0012 26.1691C10.5891 26.1629 6.20321 21.6135 6.19727 15.9996V15.7962C6.30504 10.2076 10.741 5.75683 16.1293 5.83099C21.5176 5.90515 25.8381 10.4764 25.8029 16.066C25.7677 21.6556 21.39 26.168 16.0012 26.1691ZM16.0012 7.86399C11.6695 7.86399 8.15805 11.5064 8.15805 15.9996C8.15805 20.4928 11.6695 24.1352 16.0012 24.1352C20.3328 24.1352 23.8443 20.4928 23.8443 15.9996C23.8395 11.5085 20.3308 7.86904 16.0012 7.86399ZM16.0012 21.0843L14.6188 19.6504L17.1482 17.0165H11.0992V14.9826H17.1482L14.6188 12.3487L16.0012 10.9148L20.9031 15.9996L16.0012 21.0843Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewPayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-payment.9695549e0a9329e4bb53d7dc8ac4de84.svg";